import React from 'react';
import styles from './styles/Spinner.module.css';

const Spinner = () => {
    return (
        <div className={styles.spinnerContainer}>
            <div className={styles.spinner} />
        </div>
    );
};

export default Spinner;